import module from 'finanzas/module.js'

function FinanzasReportecomisiones ($api, $export, $http, $filter) {
  this.getComisionistas = function () {
    return $http.get('/kendu/finanzas/reportecomisiones/comisionistas')
  }

  this.get = function (start, end, comisionistas, proveedores, clientes) {
    return $http.get('kendu/finanzas/reportecomisiones', {
      params: {
        start: start.toYMD(),
        end: end.toYMD(),
        comisionistas: comisionistas,
        proveedores: proveedores,
        clientes: clientes,
      },
    })

  }

  this.exportarXLS = function (data) {
    let filter = $filter('filter')
    let pages = []
    let encabezados = [
      {label: 'Folio	', format: {width: 10}},
      {label: 'ID_Nomina	', format: {width: 20}},
      {label: 'Fecha	', format: {width: 10}},
      {label: 'Nombre_Prov	', format: {width: 30}},
      {label: 'Nombre_Cte	', format: {width: 30}},
      {label: 'Serie	', format: {width: 10}},
      {label: 'SubTotal	', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Tasa	 ', format: {width: 10, align: 'right'}},
      {label: 'Importe_Tasa 	 ', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Descuento 	 ', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Total 	 ', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Importe 	 ', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Suministro 	 ', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Nom_Total_SA 	', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'ID_Esquema	', format: {width: 20}},
      {label: 'ComCte	', format: {width: 20}},
      {label: 'ID_Comisionista	', format: {width: 20}},
      {label: 'Nombre_Comisionista	', format: {width: 30}},
      {label: 'Master	', format: {width: 20}},
      {label: 'Comision_Porcentaje	', format: {width: 20}},
      {label: 'Imp_Comision	', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Concepto	', format: {width: 20}},
      {label: 'Estado	', format: {width: 20}},
      {label: 'Tipo_Moneda	', format: {width: 20}},
      {label: 'ID_Concepto_Contable	', format: {width: 20}},
      {label: 'Fecha_Movimiento	', format: {width: 20}},
      {label: 'ID_Cliente	', format: {width: 20}},
      {label: 'ID_Facturadora	', format: {width: 20}},
      {label: 'FolMovimiento	', format: {width: 20}},
      {label: 'ID_Empleado', format: {width: 20}},
    ]

    let comisionistas = data.reduce(function (prev, next) {
      return prev.concat(prev.indexOf(next.Nombre_Comisionista) < 0 ? [next.Nombre_Comisionista] : [])
    }, [])

    comisionistas.forEach(function (item) {
      pages.push(new Page(filter(data, {
        Nombre_Comisionista: item,
      }), encabezados, item.substring(0, 30)))
    })

    $export.excel('Comisionistas', pages)
  }

  function Page (data, encabezados, nombre) {
    return {
      name: nombre,
      columns: encabezados,
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data: data.map((row) => ([
        row.Folio,
        row.ID_Nomina,
        row.Fecha,
        row.Nombre_Prov,
        row.Nombre_Cte,
        row.Serie,
        row.SubTotal,
        row.Tasa,
        row.Importe_Tasa,
        row.Descuento,
        row.Total,
        row.Importe,
        row.Suministro,
        row.Nom_Total_SA,
        row.ID_Esquema,
        row.ComCte,
        row.ID_Comisionista,
        row.Nombre_Comisionista,
        row.Master,
        row.Comision_Porcentaje,
        row.Imp_Comision,
        row.Concepto,
        row.Estado,
        row.Tipo_Moneda,
        row.ID_Concepto_Contable,
        row.Fecha_Movimiento,
        row.ID_Cliente,
        row.ID_Facturadora,
        row.FolMovimiento,
        row.ID_Empleado,
      ])),
    }
  }
}

module.service('FinanzasReportecomisiones', FinanzasReportecomisiones)



// WEBPACK FOOTER //
// ./src/finanzas/_/reportecomisiones/services/FinanzasReportecomisiones.js